import api from './interceptor';

const BASE_URL_V2 = 'api/v2/network-traversal';

export default {
  // API Version 2
  getIceServers: roomId => api.get(`${BASE_URL_V2}/ice-servers`, { params: { roomId } }),
};
